/* ==========================================================================
Build Svg
========================================================================== */

const __svg__ = { path: '../images/svg/sprite/*.svg', name: './images/svg/sprite.svg' };

/* ==========================================================================
Base JS
========================================================================== */

// import 'bootstrap';
import 'foundation-sites/dist/js/foundation.min.js';

// import 'svgxuse';

// /* ==========================================================================
// Load JS from Modules
// ========================================================================== */
import '../../../blocks/analytics/analytics.js'; import '../../../blocks/banner/_banner.js'; import '../../../blocks/bonus_list/bonus_list.js'; import '../../../blocks/button/button.js'; import '../../../blocks/comments/comments.js'; import '../../../blocks/faq/faq.js'; import '../../../blocks/gallery/gallery.js'; import '../../../blocks/navbar/navbar.js'; import '../../../blocks/predictions/predictions.js'; import '../../../blocks/promocode/promocode.js'; import '../../../blocks/quick_navigation/quick_navigation.js'; import '../../../blocks/slider/slider.js'; import '../../../blocks/table/table.js';

// /* ==========================================================================
// Load Custom JS
// ========================================================================== */





